<template>
  <div>
    <pdl-tabs>
      <pdl-tab-pane>
        <span
          slot="label"
          qaid="notification-settings-grid-stockwatch-bike-label"
          v-html="getBaseProperty('bike-stockwatch')"
        />
        <notification-settings-stockwatch-grid
          :items="stockWatchBikeData.stockwatches || []"
          :base-properties="baseProperties"
          :no-item="bikesStockWatchNoItemMessage"
          qaid="notification-settings-grid-stockwatch-bike"
          @update-data-list="fetchStockWatchBikeData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span
          slot="label"
          qaid="notification-settings-grid-stockwatch-am-label"
          v-html="getBaseProperty('acc-stockwatch')"
        />
        <notification-settings-stockwatch-grid
          :items="stockWatchAftermarketData.stockwatches || []"
          :base-properties="baseProperties"
          :no-item="partsStockWatchNoItemMessage"
          qaid="notification-settings-grid-stockwatch-am"
          @update-data-list="fetchStockWatchAftermarketData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span slot="label" qaid="notification-settings-grid-eta-bike-label" v-html="getBaseProperty('bike-eta')" />
        <notification-settings-eta-grid
          :items="EtaBikeData.orderLines || []"
          :token="token"
          :base-properties="baseProperties"
          :no-item="bikesEtaNoItemMessage"
          qaid="notification-settings-grid-eta-bike"
          @update-data-list="fetchEtaBikeData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span slot="label" qaid="notification-settings-grid-eta-am-label" v-html="getBaseProperty('acc-eta')" />
        <notification-settings-eta-grid
          :items="EtaAftermarketData.orderLines || []"
          :token="token"
          :base-properties="baseProperties"
          :no-item="partsEtaNoItemMessage"
          qaid="notification-settings-grid-eta-am"
          @update-data-list="fetchEtaAftermarketData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span slot="label" qaid="notification-settings-grid-prefs-label" v-html="getBaseProperty('email-prefs')" />
        <notification-settings-email-preferences
          :columns="notificationPrefsEmailData.columns"
          :groupings="notificationPrefsData"
        />
      </pdl-tab-pane>
    </pdl-tabs>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import NotificationSettingsEtaGrid from '@/components/containers/my-account/NotificationSettingsEtaGrid';
import NotificationSettingsStockwatchGrid from '@/components/containers/my-account/NotificationSettingsStockwatchGrid';
import NotificationSettingsEmailPreferences from '@/components/containers/notifications/NotificationSettingsEmailPreferences';

export default {
  components: {
    PdlTabs,
    PdlTabPane,
    NotificationSettingsEtaGrid,
    NotificationSettingsStockwatchGrid,
    NotificationSettingsEmailPreferences,
  },
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stockWatchBikeData: [],
      stockWatchAftermarketData: [],
      EtaBikeData: [],
      EtaAftermarketData: [],
      notificationPrefsEmailData: {},
      notificationPrefsData: [],
      noItemDefaultMessage: 'Sorry, you have no watched items to display',
      bikesEtaNoItemMessage: '',
      partsEtaNoItemMessage: '',
      bikesStockWatchNoItemMessage: '',
      partsStockWatchNoItemMessage: '',
    };
  },
  computed: {},

  mounted() {
    this.fetchStockWatchBikeData();
    this.fetchStockWatchAftermarketData();
    this.fetchEtaBikeData();
    this.fetchEtaAftermarketData();
    this.fetchNotificationPrefsEmailData();
  },
  methods: {
    /* Should probably put these fetchers in a loop */
    fetchStockWatchBikeData() {
      return axios
        .get('/notification-settings/stock-watch?producttype=bike')
        .then(({data: {data, meta}}) => {
          if (data.stockwatches) {
            data.stockwatches.forEach((element) => {
              Vue.set(element, 'active', false);
            });
          }
          this.stockWatchBikeData = data;
          this.bikesStockWatchNoItemMessage =
            meta.feedback.message && meta.feedback.message != null
              ? meta.feedback.message.basePropertyValue
              : this.noItemDefaultMessage;
        })
        .catch((error) => console.error(error));
    },
    fetchStockWatchAftermarketData() {
      return axios
        .get('/notification-settings/stock-watch?producttype=am')
        .then(({data: {data, meta}}) => {
          if (data.stockwatches) {
            data.stockwatches.forEach((element) => {
              Vue.set(element, 'active', false);
            });
          }
          this.stockWatchAftermarketData = data;
          this.partsStockWatchNoItemMessage =
            meta.feedback.message && meta.feedback.message != null
              ? meta.feedback.message.basePropertyValue
              : this.noItemDefaultMessage;
        })
        .catch((error) => console.error(error));
    },
    fetchEtaBikeData() {
      return axios
        .get('/notification-settings/eta-watch?producttype=bike')
        .then(({data: {data, meta}}) => {
          if (data.orderLines) {
            data.orderLines.forEach((element) => {
              Vue.set(element, 'checkboxActive', false);
              Vue.set(element, 'etaWatch', true);
            });
          }
          this.bikesEtaNoItemMessage =
            meta.feedback.message && meta.feedback.message != null
              ? meta.feedback.message.basePropertyValue
              : this.noItemDefaultMessage;
          this.EtaBikeData = data;
        })
        .catch((error) => console.error(error));
    },
    fetchEtaAftermarketData() {
      return axios.get('/notification-settings/eta-watch?producttype=am').then(({data: {data, meta}}) => {
        if (data.orderLines) {
          data.orderLines.forEach((element) => {
            Vue.set(element, 'checkboxActive', false);
            Vue.set(element, 'etaWatch', true);
          });
        }
        this.partsEtaNoItemMessage =
          meta.feedback.message && meta.feedback.message != null
            ? meta.feedback.message.basePropertyValue
            : this.noItemDefaultMessage;
        this.EtaAftermarketData = data;
      });
    },
    fetchNotificationPrefsEmailData() {
      this.notificationPrefsEmailData = {
        columns: [
          {
            label: this.getBaseProperty('event'),
          },
          {
            label: this.getBaseProperty('online'),
            cssClasses: 'text-right',
          },
          {
            label: this.getBaseProperty('email'),
            cssClasses: 'text-right',
          },
        ],
      };
      return axios.get('notification-settings/user-preferences/').then(({data: {data}}) => {
        if (data) {
          this.notificationPrefsData = data;
        }
      });
    },
  },
};
</script>
